import React, { Component } from "react";
// Container
import Container from "./styled";
// Icons
import { IoClose } from "react-icons/io5";
import { BsCheckLg } from "react-icons/bs";
import { MdInput } from "react-icons/md";
import { IoMailOutline } from "react-icons/io5";
import { IoMailOpenOutline } from "react-icons/io5";
// Bloqueo de scroll
import disableScroll from "disable-scroll";
// ReCaptcha
import ReCAPTCHA from "react-google-recaptcha";
// Axios
import axios from "axios";
// Dropdown
import DropdownItemBaja from "./dropDownBaja";
// Fade animation
import { Fade } from "react-awesome-reveal";

// ReCaptcha Validate
function onChange(value) {
  console.log("Captcha value:", value);
}

export default class BajaDeServicioModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Estado que determina si esta anierto o no el drooDown
      isActiveUno: false,
      isActiveDos: false,
      isActiveTres: false,
      // Estados que determinan si se completaron o no los datos de cada dropDown
      datosAseguradoComplete: "incompleto",
      descripcionBienComplete: "incompleto",
      motivoComplete: "incompleto",
      // Estados que guardan los valores de los inputs
      nombrecompleto: "",
      dni: "",
      email: "",
      telefono: "",
      bienasegurado: "",
      marca: "",
      modelo: "",
      motivo: "",
    };
  }

  // Toggle para cambiar el estado cuando se abre o se cierra cada uno de los dropdowns
  // Dropdown Datos del asegurado
  handleToggleUno = () => {
    // Si no esta abierto
    if (this.state.isActiveUno == false) {
      // Setea todos cerrados y este abierto
      this.setState({
        isActiveUno: true,
        isActiveDos: false,
        isActiveTres: false,
      });
    }
    // Si esta abierto
    else {
      return;
    }
  };

  // Dropdown Descricion del bien asegurado
  handleToggleDos = () => {
    if (this.state.isActiveDos == false) {
      this.setState({
        isActiveUno: false,
        isActiveDos: true,
        isActiveTres: false,
      });
    } else {
      return;
    }
  };

  // Dropdown Motivo de la baja
  handleToggleTres = () => {
    if (this.state.isActiveTres == false) {
      this.setState({
        isActiveUno: false,
        isActiveDos: false,
        isActiveTres: true,
      });
    } else {
      return;
    }
  };

  // Cuando se abre pone el primero en true ya que aparece abierto de una
  // Ya se hace por default pero se deja por las dudas
  componentWillMount = () => {
    this.handleToggleUno();
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
    // Datos personales
    if (
      this.state.nombrecompleto != "" &&
      this.state.dni != "" &&
      this.state.email != "" &&
      this.state.telefono != ""
    ) {
      this.state.datosAseguradoComplete = "completado";
    } else {
      this.state.datosAseguradoComplete = "incompleto";
    }
    // Bienes Asegurados
    if (
      this.state.bienasegurado != "" &&
      this.state.marca != "" &&
      this.state.modelo != ""
    ) {
      this.state.descripcionBienComplete = "completado";
    } else {
      this.state.descripcionBienComplete = "incompleto";
    }
    // Motivo
    if (this.state.motivo != "") {
      this.state.motivoComplete = "completado";
    } else {
      this.state.motivoComplete = "incompleto";
    }
  };

  selectChange(event) {
    this.state.bienasegurado = event.target.value;
  }

  // Setear estado del captcha
  handleCaptcha = (value) => {
    this.setState({ ["captcha"]: value });
  };

  // Validación de errores en el formulario
  validateForm = () => {
    // Objeto que almacena los errores según el campo
    let errors = {};

    // Nombre
    if (!this.state.nombrecompleto) {
      errors.nombrecompleto = "Este campo es requerido.";
    } else if (this.state.nombrecompleto.length < 2) {
      errors.nombrecompleto = "El campo debe contener al menos 2 caracteres.";
    } else if (
      !/^[a-zA-Z\u00C0-\u017F!@#$%^&':"\\|,.<>\/?\s\u00f1\u00d1]*$/.test(
        this.state.nombrecompleto
      )
    ) {
      errors.nombrecompleto = "El nombre ingresado no es válido.";
    }

    // DNI
    if (!this.state.dni) {
      errors.dni = "Este campo es requerido.";
    }

    // Email
    if (!this.state.email) {
      errors.email = "Este campo es requerido";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.state.email)) {
      errors.email = "El email ingresado no es valido.";
    }

    // Teléfono
    if (!this.state.telefono) {
      errors.telefono = "Este campo es requerido";
    } else if (this.state.telefono.length < 8) {
      errors.telefono = "El campo telefono es menor a 8 digitos.";
    }

    // Bien Asegurado
    if (!this.state.bienasegurado) {
      errors.bienasegurado = "Este campo es requerido.";
    }

    // Motivo
    if (!this.state.motivo) {
      errors.motivo = "Este campo es requerido.";
    }

    // Marca
    if (!this.state.marca) {
      errors.marca = "Este campo es requerido.";
    }

    // Modelo
    if (!this.state.modelo) {
      errors.modelo = "Este campo es requerido.";
    }

    // Captcha
    /*
    if (!this.state.captcha) {
      errors.captcha = "Este campo es requerido.";
    }
    */

    console.log(errors);
    this.setState({ formErrors: errors });

    // Si el objeto errors está vacío, ir al paso siguiente.
    if (Object.keys(errors).length === 0) {
      this.sendMail();
      this.props.nextStep();
    }
  };

  // Enviar mail
  sendMail = async () => {
    const mailContent = `
      <html><body>
        <h2>Solicitud de BAJA desde SeguroBici</h2>
        <h2>N° de tramite: Acá va el ID de la tabla sw_bajas_web</h2>
        <h3>Datos del Asegurado</h3>
        <p><b>Nombre:</b> ${this.state.nombrecompleto}</p>
        <p><b>DNI:</b> ${this.state.dni}</p>
        <p><b>Email:</b> ${this.state.email}</p>
        <p><b>Teléfono:</b> ${this.state.telefono}</p>
        <h3>Descripción del bien asegurado</h3>
        <p><b>Producto:</b> ${this.state.bienasegurado}</p>
        <p><b>Marca:</b> ${this.state.marca}</p>
        <p><b>Modelo:</b> ${this.state.modelo}</p>
        <h3>Motivo de la solicitud de baja</h3>
        <p>${this.state.motivo}</p>
      </body></html>
    `
    // Data para el mail
    const mailData = {
      mail: [this.state.email],
      subject: `Solicitud de BAJA web ${this.state.nombrecompleto}`,
      htmlContent: mailContent
    };

    const sendMail = await axios.post('http://localhost:5000/send_email', mailData)
    console.log(sendMail)
  }

  render() {
    const isActiveUno = this.state.isActiveUno;
    const isActiveDos = this.state.isActiveDos;
    const isActiveTres = this.state.isActiveTres;
    // Disable scroll on
    this.props.toggleScroll != "" && disableScroll.on();
    return (
      <Container>
        {/* Modal Box */}
        <div className="box topInOpacity5">
          {/* Close Button Container */}
          <div className="closeButtonContainer">
            {/* Button */}
            <a onClick={this.props.handleClose}>
              {/* X Icon */}
              <IoClose />
            </a>
          </div>
          {/* Title */}
          <h3>¿Querés dar de baja tu Seguro?</h3>
          {/* Subtitle */}
          <p id="completa">Completá los siguientes formularios</p>
          {/* DropDown Containers */}
          <div className="dropDownsContainer">
            {/* DropDown Datos del asegurado */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveUno == true
                  ? "dropDownContainerOpen"
                  : "dropDownContainer"
              }
            >
              <DropdownItemBaja
                title="Datos del asegurado"
                clickFunction={this.handleToggleUno}
                isActive={this.state.isActiveUno}
                isCompleted={
                  <div className="tagImageContainer">
                    <div className="dataTag">
                      {this.state.datosAseguradoComplete == "completado" && (
                        <span className="completado">
                          <BsCheckLg />
                        </span>
                      )}
                      {this.state.datosAseguradoComplete == "completado" && (
                        <p className="completado">COMPLETADO</p>
                      )}
                      {this.state.datosAseguradoComplete == "error" && (
                        <span className="error">
                          <BsCheckLg />
                        </span>
                      )}
                      {this.state.datosAseguradoComplete == "error" && (
                        <p className="error">ERROR</p>
                      )}
                      {this.state.datosAseguradoComplete == "incompleto" && (
                        <span>
                          <MdInput />
                        </span>
                      )}
                      {this.state.datosAseguradoComplete == "incompleto" && (
                        <p>FALTAN DATOS</p>
                      )}
                    </div>
                    <div
                      className={
                        isActiveUno
                          ? "buttonIconCloseContainer"
                          : "buttonIconOpenContainer"
                      }
                    >
                      <img
                        id="buttonIcon"
                        alt={isActiveUno ? "Cerrar" : "Abrir"}
                        src={
                          isActiveUno
                            ? "images/home/preguntas/accordion/arrowUp.svg"
                            : "images/home/preguntas/accordion/plus.svg"
                        }
                      ></img>
                    </div>
                  </div>
                }
              >
                {/* Datos del asegurado */}
                <div className="inputsContainer opacidad04">
                  {/* Nombre */}
                  <div className="inputContainer">
                    <label>Nombre completo</label>
                    <input
                      placeholder="Ingresá tu nombre completo"
                      name="nombrecompleto"
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      value={this.state.nombrecompleto}
                      type="text"
                    ></input>
                  </div>
                  {/* DNI */}
                  <div className="inputContainer">
                    <label>DNI</label>
                    <input
                      placeholder="Ingresá tu DNI"
                      name="dni"
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      value={this.state.dni}
                      type="number"
                    ></input>
                  </div>
                  {/* Email */}
                  <div className="inputContainer">
                    <label>Email</label>
                    <input
                      placeholder="Ingresá tu email"
                      name="email"
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      value={this.state.email}
                      type="email"
                    ></input>
                  </div>
                  {/* Telefono */}
                  <div className="inputContainer">
                    <label>Teléfono</label>
                    <input
                      placeholder="Ingresá tu número de teléfono"
                      name="telefono"
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      value={this.state.telefono}
                      type="number"
                    ></input>
                  </div>
                </div>
              </DropdownItemBaja>
            </Fade>
            {/* DropDown Descripción del bien asegurado */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveDos == true
                  ? "dropDownContainerOpen"
                  : "dropDownContainer"
              }
            >
              <DropdownItemBaja
                title="Descripción del bien asegurado"
                clickFunction={this.handleToggleDos}
                isActive={this.state.isActiveDos}
                isCompleted={
                  <div className="tagImageContainer">
                    <div className="dataTag">
                      {this.state.descripcionBienComplete == "completado" && (
                        <span className="completado">
                          <BsCheckLg />
                        </span>
                      )}
                      {this.state.descripcionBienComplete == "completado" && (
                        <p className="completado">COMPLETADO</p>
                      )}
                      {this.state.descripcionBienComplete == "error" && (
                        <span className="error">
                          <BsCheckLg />
                        </span>
                      )}
                      {this.state.descripcionBienComplete == "error" && (
                        <p className="error">ERROR</p>
                      )}
                      {this.state.descripcionBienComplete == "incompleto" && (
                        <span>
                          <MdInput />
                        </span>
                      )}
                      {this.state.descripcionBienComplete == "incompleto" && (
                        <p>FALTAN DATOS</p>
                      )}
                    </div>
                    <div
                      className={
                        isActiveDos
                          ? "buttonIconCloseContainer"
                          : "buttonIconOpenContainer"
                      }
                    >
                      <img
                        id="buttonIcon"
                        alt={isActiveDos ? "Cerrar" : "Abrir"}
                        src={
                          isActiveDos
                            ? "images/home/preguntas/accordion/arrowUp.svg"
                            : "images/home/preguntas/accordion/plus.svg"
                        }
                      ></img>
                    </div>
                  </div>
                }
              >
                {/* Descripción del bien asegurado */}
                <div className="inputsContainer opacidad04">
                  {/* Bien Asegurado */}
                  <label id="selectLabel">Bien Asegurado</label>
                  <div className="selectContainer">
                    <select
                      name="bienasegurado"
                      value={this.state.bienasegurado}
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                    >
                      <option value="" disabled>
                        Seleccionar
                      </option>
                      <option value="bicicleta">Bicicleta</option>
                      <option value="monopatin">Monopatín</option>
                    </select>
                    <i></i>
                  </div>
                  {/* Marca */}
                  <div className="inputContainer">
                    <label>Marca</label>
                    <input
                      placeholder="Ingresá la marca"
                      name="marca"
                      value={this.state.marca}
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      type="text"
                    ></input>
                  </div>
                  {/* Modelo */}
                  <div className="inputContainer">
                    <label>Modelo</label>
                    <input
                      placeholder="Ingresá el modelo"
                      name="modelo"
                      value={this.state.modelo}
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      type="text"
                    ></input>
                  </div>
                </div>
              </DropdownItemBaja>
            </Fade>
            {/* DropDown Motivo de la baja */}
            <Fade
              delay={100}
              duration={600}
              triggerOnce={true}
              className={
                this.state.isActiveTres == true
                  ? "dropDownContainerOpen"
                  : "dropDownContainer"
              }
            >
              <DropdownItemBaja
                title="Motivo de la baja"
                clickFunction={this.handleToggleTres}
                isActive={this.state.isActiveTres}
                isCompleted={
                  <div className="tagImageContainer">
                    <div className="dataTag">
                      {this.state.motivoComplete == "completado" && (
                        <span className="completado">
                          <BsCheckLg />
                        </span>
                      )}
                      {this.state.motivoComplete == "completado" && (
                        <p className="completado">COMPLETADO</p>
                      )}
                      {this.state.motivoComplete == "error" && (
                        <span className="error">
                          <BsCheckLg />
                        </span>
                      )}
                      {this.state.motivoComplete == "error" && (
                        <p className="error">ERROR</p>
                      )}
                      {this.state.motivoComplete == "incompleto" && (
                        <span>
                          <MdInput />
                        </span>
                      )}
                      {this.state.motivoComplete == "incompleto" && (
                        <p>FALTAN DATOS</p>
                      )}
                    </div>
                    <div
                      className={
                        isActiveTres
                          ? "buttonIconCloseContainer"
                          : "buttonIconOpenContainer"
                      }
                    >
                      <img
                        id="buttonIcon"
                        alt={isActiveTres ? "Cerrar" : "Abrir"}
                        src={
                          isActiveTres
                            ? "images/home/preguntas/accordion/arrowUp.svg"
                            : "images/home/preguntas/accordion/plus.svg"
                        }
                      ></img>
                    </div>
                  </div>
                }
              >
                {/* Motivo de la baja */}
                <div className="motivoContainer opacidad04">
                  {/* Motivo de la baja */}
                  <div className="textAreaContainer">
                    <label>¿Por qué estas dando de baja el servicio?</label>
                    <textarea
                      placeholder="Ingresá el motivo de la baja"
                      name="motivo"
                      value={this.state.motivo}
                      onFocus={this.handleInputChange}
                      onChange={this.handleInputChange}
                      onBlur={this.handleInputChange}
                      type="text"
                    ></textarea>
                  </div>
                </div>
              </DropdownItemBaja>
            </Fade>
          </div>
          {/* ReCAPTCHA Container */}
          <div className="reCaptchaContainer">
            <ReCAPTCHA
              sitekey="6LfvW5YdAAAAADsIry4KRJS5YkcRb7L20iJbYLzQ"
              onChange={onChange}
            />
          </div>
          {this.state.datosAseguradoComplete == "completado" &&
          this.state.descripcionBienComplete == "completado" &&
          this.state.motivoComplete == "completado" ? (
            <button id="formButton" onClick={this.validateForm}>
              <span>
                <IoMailOutline />
              </span>
              Enviar
            </button>
          ) : (
            <button id="formButtonDisable">
              <span>
                <IoMailOpenOutline />
              </span>
              Enviar
            </button>
          )}
        </div>
      </Container>
    );
  }
}
